import { useEffect, useState } from 'react'
import { useLocation, useNavigate, useParams, useSearchParams } from 'react-router-dom'

import { Box } from '@mui/material'
import { useMappedTranslation } from 'hooks'
import { getConsentApi } from 'pages/policies/api'
import { Consent, VIEW_TYPE, buildPolicySearch } from 'pages/policies/utils'
import Detail from 'pages/policies/views/detail'
import List from 'pages/policies/views/list'
import { convertCountryCode2to3, countryCode } from 'utils/i18n'

export const ServicesList = () => {
  const t = useMappedTranslation()
  const { versionId } = useParams()
  const [searchParams] = useSearchParams()
  const navigate = useNavigate()
  const location = useLocation()
  const view_type = versionId ? VIEW_TYPE.DETAIL : VIEW_TYPE.LIST
  const paramCountryCode = searchParams.get('countryCode') || undefined
  const paramLocale = searchParams.get('locale') || undefined
  const policySearch = buildPolicySearch(searchParams)
  const effectiveCountryCode = paramCountryCode ? convertCountryCode2to3(paramCountryCode) : countryCode

  const [isLoading, setIsLoading] = useState<boolean>(true)
  const [consents, setConsents] = useState<Consent[]>()
  const [targetConsent, setTargetConsent] = useState<Consent>()
  const [detail, setDetail] = useState<string>('<div/>')

  const getConsent = () => {
    return getConsentApi('PDP', true)
      .then((res) => {
        if (res.status !== 200) {
          throw new Error('Failed getConsentBody')
        } else {
          const data = res.data as Consent[]
          setConsents(data)
          return data
        }
      })
      .catch(() => {
        setConsents([])
        setTargetConsent(undefined)
        setDetail('<div>Failed to load</div>')
      })
      .finally(() => {
        setIsLoading(false)
      })
  }

  const handleButton = (item) => {
    return navigate(`/policies/privacy-notices/services/${item.appKey}/${item.version}${policySearch}`, {
      state: { consent: item }
    })
  }

  useEffect(() => {
    setIsLoading(true)
    if (effectiveCountryCode !== 'KOR') {
      navigate(`/error/404?url=${location.pathname}`, { replace: true })
    }

    getConsent()
  }, [versionId, effectiveCountryCode, paramCountryCode, paramLocale])

  return (
    <Box>
      {view_type === VIEW_TYPE.LIST ? (
        <List
          title={t('iam.membership.Common.Title.ServicePP')}
          consents={consents}
          isLoading={isLoading}
          handleListButton={handleButton}
        />
      ) : (
        <Detail title={(targetConsent && targetConsent.title) || ''} isLoading={isLoading} detail={detail} />
      )}
    </Box>
  )
}
